<div class="profile-container">
  <div class="row no-gutter">
    <div class="col col-sm-12 col-lg-12 col-xs-12 profile">
      <div class="basic">
        <h6 class="info">Basic Information</h6>
      </div>
      <div class="form-container">
        <form class="example-form" [formGroup]="profileForm" autocomplete="off">
          <div class="row mb-2">
            <div class="col">
              <label for="firstname" class="form-label required">First Name</label>
              <input type="text" class="form-control form-control-sm" aria-label="fname" formControlName="firstname"
                placeholder="First Name" autocomplete="off" value="" minlength="2" maxlength="30" required
                [readonly]="isEditable" (change)="onValueChange()" />
                <div class="error-section">
                  @if (
                    profileForm.controls.firstname.errors &&
                    profileForm.controls.firstname.touched &&
                    profileForm.controls.firstname.dirty
                    ) {
                  <p class="err-msg" [hidden]="
                      !profileForm.get('firstname').hasError('required')
                    ">
                      First Name is required
                    </p>
                  <p class="err-msg" [hidden]="
                      !profileForm.get('firstname').hasError('minlength')
                    ">
                      Minimum 2 characters required
                    </p>
                  }
                </div>
              </div>

              <div class="col">
                <label for="lastname" class="form-label required">Last Name</label>
                <input type="text" class="form-control form-control-sm" aria-label="lname" formControlName="lastname"
                  placeholder="Last Name" autocomplete="off" value="" minlength="1" maxlength="30" required
                  [readonly]="isEditable" (change)="onValueChange()" />
                  <div class="error-section">
                    @if (
                      profileForm.controls.lastname.errors &&
                      profileForm.controls.lastname.touched &&
                      profileForm.controls.lastname.dirty
                      ) {
                      <p class="err-msg" [hidden]="!profileForm.get('lastname').hasError('required')">
                        Last Name is required
                      </p>
                  <p class="err-msg" [hidden]="
                      !profileForm.get('lastname').hasError('minlength')
                    ">
                        Minimum 1 character required
                      </p>
                    }
                  </div>
                </div>
                @if (
                  authDetails.userDetails.role == 'superadmin' &&
                  authDetails.userDetails.email
                  ) {
                  <div class="col">
                    <label for="email" class="form-label required">Email Id</label>
                    <input type="text" class="form-control form-control-sm" aria-label="lname" formControlName="email"
                      placeholder="Email Id" autocomplete="off" value="" required [readonly]="isEditable"
                      (change)="onValueChange()" />
                      <div class="error-section">
                        @if (
                          profileForm.controls.email.errors &&
                          profileForm.controls.email.touched &&
                          profileForm.controls.email.dirty
                          ) {
                          <p class="err-msg" [hidden]="!profileForm.get('email').hasError('pattern')">
                            Invalid Email Address
                          </p>
                        }
                      </div>
                    </div>
                  }
                </div>
                <div class="row mb-2">
                  <div class="col">
                    <label for="vendor" class="form-label required">Company/Vendor</label><br />

                    @if (authDetails.userDetails.role !== 'superadmin') {
                      <input type="text"
                class="form-control form-control-sm" placeholder="Company/Vendor" aria-label="company" readonly value="{{
                  sharedService.vendorName
                    ? sharedService.vendorName
                    : authDetails.userDetails.vendor.orgName
                }}" />
                    }
                    @if (authDetails.userDetails.role === 'superadmin') {
                      <input type="text"
                        class="form-control form-control-sm" placeholder="Company/Vendor" aria-label="company"
                [readonly]="isEditable" value="{{
                  sharedService.vendorName
                    ? sharedService.vendorName
                    : authDetails.userDetails.vendor.orgName
                }}" (change)="onValueChange()" />
                    }
                  </div>

                  <div class="col">
                    <label for="mobile" class="form-label required">Mobile Number</label>
                    <input type="text" class="form-control form-control-sm" aria-label="mobile" formControlName="mobile"
                      type="text" minlength="10" maxlength="10" placeholder="Mobile Number" autocomplete="off" value=""
                      [validateInput]="{ 'mobile-number': true }" required [readonly]="isDisabled || isEditable"
                      (change)="onValueChange()" />
                      <div class="error-section">
                        @if (
                          profileForm.controls.mobile.errors ||
                          (profileForm.controls.mobile.touched &&
                          profileForm.controls.mobile.dirty)
                          ) {
                          <p class="err-msg" [hidden]="!profileForm.get('mobile').hasError('required')">
                            Mobile Number required
                          </p>
                          <p class="err-msg" [hidden]="!profileForm.get('mobile').hasError('pattern')">
                            Mobile Number is invalid
                          </p>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="managermobile" class="form-label required">Reporting Manager Number</label>
                      <input type="text" class="form-control form-control-sm" aria-label="reportingmanager"
                        formControlName="reportingmanager" type="text" minlength="10" maxlength="10"
                        placeholder="Reporting Manager Number" autocomplete="off" value=""
                        [validateInput]="{ 'mobile-number': true }" required (change)="onValueChange()" [readonly]="true" />
                        <div class="error-section">
                          @if (
                            profileForm.controls.reportingmanager.errors ||
                            (profileForm.controls.reportingmanager.touched &&
                            profileForm.controls.reportingmanager.dirty)
                            ) {
                            <p class="err-msg" [hidden]="!profileForm.get('mobile').hasError('required')">
                              Reporting Manager Mobile Number required
                            </p>
                            <p class="err-msg" [hidden]="!profileForm.get('mobile').hasError('pattern')">
                              Mobile Number is invalid
                            </p>
                          }
                        </div>
                      </div>
                      <div class="col">
                        <label for="role" class="form-label required">Select Role</label><br />
                        <input type="text" class="form-control form-control-sm" aria-label="mobile" formControlName="role"
                          type="text" minlength="10" maxlength="10" placeholder="" autocomplete="off" value="" required
                          [readonly]="true" />
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>